import React from "react";
import { Button } from "../components/ui/button";

interface DeleteConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onDelete: () => void;
  loading?: boolean;
}

export function DeleteConfirmationModal({ open, onCancel, onDelete, loading }: DeleteConfirmationModalProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-slate-900 p-6 rounded-lg shadow-lg w-full max-w-sm">
        <h2 className="text-lg font-bold mb-2">Delete Workout Log?</h2>
        <p className="mb-4 text-sm text-muted-foreground">
          Are you sure you want to delete this workout log? This action cannot be undone.
        </p>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onCancel} disabled={loading}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onDelete} loading={loading}>
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
}
